import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnInit, Output, QueryList, ViewChild, ViewChildren, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TrackerTabsService, TrackerTabState } from '../../../../tracker-tabs.service';
import { CreateDisclosureSharedService, EntityNameChange } from '../../create-disclosure-shared.service';
import { DSTSavePayload } from '../../dst-dynamic-component-resolver.service';
import { DSTConsolGroup, TemplateHeaderComponent } from '../template-header/template-header.component';
import { TemplateHeaderService } from '../template-header/template-header.service';
import { DSTEntityDetails, TemplateLeidSelectorComponent } from '../template-leid-selector/template-leid-selector.component';
import { HttpErrorResponse } from '@angular/common/http';
import { DSTFormState, StmtAttrData } from '../../../../../shared/models/dst-form-state.model';
import { DSTSharedService } from '../../../../../shared/dst-shared.service';
import { stripAmountFormatting } from '../../dst-amount.util';
import {toSaveString, safeEntityField, safeEntityId} from '../../dst-save.util';

@Component({
    selector: 'dst-template-sec8824-id237',
    templateUrl: './template-sec8824-id237.component.html',
    styleUrls: ['../template-shared.scss', './template-sec8824-id237.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class TemplateSec8824Id237Component implements OnInit, AfterViewInit {
  private readonly destroyRef = inject(DestroyRef);


  @ViewChild(TemplateHeaderComponent)
  private headerComponent!: TemplateHeaderComponent;

  @ViewChildren(TemplateLeidSelectorComponent)
  private leidComponents!: QueryList<TemplateLeidSelectorComponent>;

  @Output('onSave') onSave: EventEmitter<DSTSavePayload> = new EventEmitter<DSTSavePayload>();
  @Output('onCancel') onCancel: EventEmitter<null> = new EventEmitter<null>();

  form237!: UntypedFormGroup;
  selectedOptionID!: Event;
  dcnId!: number;
  startLoader: boolean = false;
  statementId: string = '';
  attMap: { [key: string]: string[] } = {};
  editMode: boolean = false;

  transferor!: DSTEntityDetails | null;
  transferee!: DSTEntityDetails | null;
  beginDate!: Date;
  endDate!: Date;
  DescOfLikeKindPropertyGivenUp: string = '';
  DescriptionOfOtherPropertyGivenUp: string = '';
  DescOfLikeKindPropertyReceived: string = '';
  DescriptionOfOtherPropertyRcvd: string = '';
  DateLikeKindPropertyGivenUpAcq: string | Date = '';
  DatePropActuallyTransferred: string | Date = '';
  DateLikeKindPropRcvdIdentified: string | Date = '';
  DatePropertyActuallyReceived: string | Date = '';
  ExchangeMadeWithRelatedParty!: boolean | undefined;

  RelationshipToYou: string = '';
  RelatedPartySoldPropReceived: boolean = false;
  YouSoldPropertyReceived: boolean = false;
  DisposWasAfterDeathRltdParties: boolean = false;
  DisposWasInvoluntaryConversion: boolean = false;
  ExchangeDisposNotTaxAvoidance: boolean = false;
  PrincipalPrpsRltdPartyExchStmtExplanation: string = '';

  GainInMultiAssetExchangesStmtGainInMultiAssetExchangeAmount: string = '';
  GainInMultiAssetExchangesStmtGainInMultiAssetExchangeExplanation: string = '';
  FMVOfOtherPropertyGivenUp: string = '';
  AdjBasisOfOtherPropertyGivenUp: string = '';
  GainLossOnOtherPropertyGivenUp: string = '';
  CashFMVAndNetLiabRedByExpenses: string = '';
  FMVOfLikeKindPropertyReceived: string = '';
  AmountRealized: string = '';
  AdjBasisOfLikeKindPropGivenUp: string = '';
  RealizedGainOrLoss: string = '';
  SmallerGainOrLoss: string = '';
  OrdinaryIncmUndRecaptureRules: string = '';
  SmallerGainLossLessOrdnryIncm: string = '';
  RecognizedGain: string = '';
  DeferredGainOrLoss: string = '';
  BasisOfLikeKindPropertyRcvd: string = '';
  BasisOfLikeKindIntagblePropertyRcvd: string = '';
  BasisOfLikeKindSect1245PropertyRcvd: string = '';
  BasisOfLikeKindSect1250PropertyRcvd: string = '';

  showDREMsg: boolean = false;
  DREMsg: string = '';
  taxYear: string;
  nameChangeChecked: boolean = false;

  constructor(private formBuilder: UntypedFormBuilder,
    private dstSharedService: DSTSharedService,
    private sharedService: CreateDisclosureSharedService,
    private headerService: TemplateHeaderService,
    private trackerTabsService: TrackerTabsService,
    private cdref: ChangeDetectorRef) {
    this.taxYear = this.sharedService.getActiveFormState().taxYear.toString();
  }

  ngOnInit(): void {
    this.editMode = true;
    this.beginDate = new Date(1700, 0, 1);
    this.endDate = new Date((this.sharedService.getActiveFormState()?.taxYear || 2021) + 2, 11, 31);
    this.form237 = this.formBuilder.group({
      header: this.formBuilder.group({
        consolGroup: ['', Validators.required],
        options: ['']
      }),
      partOne: this.formBuilder.group({
        DescOfLikeKindPropertyGivenUp: ['', Validators.required],
        DescriptionOfOtherPropertyGivenUp: [''],
        DescOfLikeKindPropertyReceived: ['', Validators.required],
        DescriptionOfOtherPropertyRcvd: [''],
        DateLikeKindPropertyGivenUpAcq: [''],
        DatePropActuallyTransferred: [''],
        DateLikeKindPropRcvdIdentified: [''],
        DatePropertyActuallyReceived: [''],
        ExchangeMadeWithRelatedParty: [this.ExchangeMadeWithRelatedParty],

      }),
      partTwo: this.formBuilder.group({
        RelationshipToYou: [''],
        RelatedPartySoldPropReceived: [''],
        YouSoldPropertyReceived: [''],
        DisposWasAfterDeathRltdParties: [''],
        DisposWasInvoluntaryConversion: [''],
        ExchangeDisposNotTaxAvoidance: [''],
        PrincipalPrpsRltdPartyExchStmtExplanation: [''],
      }),
      partThree: this.formBuilder.group({
        GainInMultiAssetExchangesStmtGainInMultiAssetExchangeAmount: [''],
        GainInMultiAssetExchangesStmtGainInMultiAssetExchangeExplanation: [''],
        FMVOfOtherPropertyGivenUp: [''],
        AdjBasisOfOtherPropertyGivenUp: [''],
        GainLossOnOtherPropertyGivenUp: [''],
        CashFMVAndNetLiabRedByExpenses: [''],
        FMVOfLikeKindPropertyReceived: [''],
        AmountRealized: [''],
        AdjBasisOfLikeKindPropGivenUp: [''],
        RealizedGainOrLoss: [''],
        SmallerGainOrLoss: [''],
        OrdinaryIncmUndRecaptureRules: [''],
        SmallerGainLossLessOrdnryIncm: [''],
        RecognizedGain: [''],
        DeferredGainOrLoss: [''],
        BasisOfLikeKindPropertyRcvd: [''],
        BasisOfLikeKindIntagblePropertyRcvd: [''],
        BasisOfLikeKindSect1245PropertyRcvd: [''],
        BasisOfLikeKindSect1250PropertyRcvd: ['']
      })
    });
  }

  ngAfterViewInit(): void {
    this.loadStmtData();
  }

  private loadStmtData(): void {
    const data = this.sharedService.getFormData();
    if (data) {
      this.statementId = data.isCopiedStatement ? '' : data.statementid.toString();
      this.dcnId = parseInt(data.dcnid!);
      this.editMode = true;
      data.children?.forEach((stmt: StmtAttrData) => {
        if (this.attMap[stmt.attributeName] == undefined) {
          this.attMap[stmt.attributeName] = [];
        }

        if (stmt.attributeValue != null) {
          this.attMap[stmt.attributeName].push(stmt.attributeValue);
        }
      });
      if (this.attMap['DescOfLikeKindPropertyGivenUp']) {
        this.DescOfLikeKindPropertyGivenUp = this.attMap['DescOfLikeKindPropertyGivenUp'][0];
      }
      if (this.attMap['DescriptionOfOtherPropertyGivenUp']) {
        this.DescriptionOfOtherPropertyGivenUp = this.attMap['DescriptionOfOtherPropertyGivenUp'][0];
      }
      if (this.attMap['DescOfLikeKindPropertyReceived']) {
        this.DescOfLikeKindPropertyReceived = this.attMap['DescOfLikeKindPropertyReceived'][0];
      }
      if (this.attMap['DescriptionOfOtherPropertyRcvd']) {
        this.DescriptionOfOtherPropertyRcvd = this.attMap['DescriptionOfOtherPropertyRcvd'][0];
      }
      if (this.attMap['RelationshipToYou']) {
        this.RelationshipToYou = this.attMap['RelationshipToYou'][0];
      }
      if (this.attMap['PrincipalPrpsRltdPartyExchStmtExplanation']) {
        this.PrincipalPrpsRltdPartyExchStmtExplanation = this.attMap['PrincipalPrpsRltdPartyExchStmtExplanation'][0] !== undefined ? this.attMap['PrincipalPrpsRltdPartyExchStmtExplanation'][0] : '';
      }
      if (this.attMap['GainInMultiAssetExchangesStmtGainInMultiAssetExchangeAmount']) {
        this.GainInMultiAssetExchangesStmtGainInMultiAssetExchangeAmount = this.attMap['GainInMultiAssetExchangesStmtGainInMultiAssetExchangeAmount'][0];
      }
      if (this.attMap['GainInMultiAssetExchangesStmtGainInMultiAssetExchangeExplanation']) {
        this.GainInMultiAssetExchangesStmtGainInMultiAssetExchangeExplanation = this.attMap['GainInMultiAssetExchangesStmtGainInMultiAssetExchangeExplanation'][0];
      }
      if (this.attMap['FMVOfOtherPropertyGivenUp']) {
        this.FMVOfOtherPropertyGivenUp = this.attMap['FMVOfOtherPropertyGivenUp'][0];
      }
      if (this.attMap['AdjBasisOfOtherPropertyGivenUp']) {
        this.AdjBasisOfOtherPropertyGivenUp = this.attMap['AdjBasisOfOtherPropertyGivenUp'][0];
      }
      if (this.attMap['GainLossOnOtherPropertyGivenUp']) {
        this.GainLossOnOtherPropertyGivenUp = this.attMap['GainLossOnOtherPropertyGivenUp'][0];
      }
      if (this.attMap['CashFMVAndNetLiabRedByExpenses']) {
        this.CashFMVAndNetLiabRedByExpenses = this.attMap['CashFMVAndNetLiabRedByExpenses'][0];
      }
      if (this.attMap['FMVOfLikeKindPropertyReceived']) {
        this.FMVOfLikeKindPropertyReceived = this.attMap['FMVOfLikeKindPropertyReceived'][0];
      }
      if (this.attMap['AmountRealized']) {
        this.AmountRealized = this.attMap['AmountRealized'][0];
      }
      if (this.attMap['AdjBasisOfLikeKindPropGivenUp']) {
        this.AdjBasisOfLikeKindPropGivenUp = this.attMap['AdjBasisOfLikeKindPropGivenUp'][0];
      }
      if (this.attMap['RealizedGainOrLoss']) {
        this.RealizedGainOrLoss = this.attMap['RealizedGainOrLoss'][0];
      }
      if (this.attMap['SmallerGainOrLoss']) {
        this.SmallerGainOrLoss = this.attMap['SmallerGainOrLoss'][0];
      }
      if (this.attMap['OrdinaryIncmUndRecaptureRules']) {
        this.OrdinaryIncmUndRecaptureRules = this.attMap['OrdinaryIncmUndRecaptureRules'][0];
      }
      if (this.attMap['SmallerGainLossLessOrdnryIncm']) {
        this.SmallerGainLossLessOrdnryIncm = this.attMap['SmallerGainLossLessOrdnryIncm'][0];
      }
      if (this.attMap['RecognizedGain']) {
        this.RecognizedGain = this.attMap['RecognizedGain'][0];
      }
      if (this.attMap['DeferredGainOrLoss']) {
        this.DeferredGainOrLoss = this.attMap['DeferredGainOrLoss'][0];
      }
      if (this.attMap['BasisOfLikeKindPropertyRcvd']) {
        this.BasisOfLikeKindPropertyRcvd = this.attMap['BasisOfLikeKindPropertyRcvd'][0];
      }
      if (this.attMap['BasisOfLikeKindSect1250PropertyRcvd']) {
        this.BasisOfLikeKindSect1250PropertyRcvd = this.attMap['BasisOfLikeKindSect1250PropertyRcvd'][0];
      }
      if (this.attMap['BasisOfLikeKindSect1245PropertyRcvd']) {
        this.BasisOfLikeKindSect1245PropertyRcvd = this.attMap['BasisOfLikeKindSect1245PropertyRcvd'][0];
      }
      if (this.attMap['BasisOfLikeKindIntagblePropertyRcvd']) {
        this.BasisOfLikeKindIntagblePropertyRcvd = this.attMap['BasisOfLikeKindIntagblePropertyRcvd'][0];
      }
      this.onCalculateAll();

      if (this.attMap['DateLikeKindPropertyGivenUpAcq'] && this.attMap['DateLikeKindPropertyGivenUpAcq'][0]) {
        this.DateLikeKindPropertyGivenUpAcq = this.toDateOnly(this.attMap['DateLikeKindPropertyGivenUpAcq'][0]);
      }
      if (this.attMap['DatePropActuallyTransferred'] && this.attMap['DatePropActuallyTransferred'][0]) {
        this.DatePropActuallyTransferred = this.toDateOnly(this.attMap['DatePropActuallyTransferred'][0]);
      }
      if (this.attMap['DateLikeKindPropRcvdIdentified'] && this.attMap['DateLikeKindPropRcvdIdentified'][0]) {
        this.DateLikeKindPropRcvdIdentified = this.toDateOnly(this.attMap['DateLikeKindPropRcvdIdentified'][0]);
      }
      if (this.attMap['DatePropertyActuallyReceived'] && this.attMap['DatePropertyActuallyReceived'][0]) {
        this.DatePropertyActuallyReceived = this.toDateOnly(this.attMap['DatePropertyActuallyReceived'][0]);
      }

      if (this.attMap['ExchangeMadeWithRelatedParty'] && this.attMap['ExchangeMadeWithRelatedParty'][0]) {
        this.ExchangeMadeWithRelatedParty = (this.attMap['ExchangeMadeWithRelatedParty'][0] === '1') ? true : (this.attMap['ExchangeMadeWithRelatedParty'][0] == '0' ? false : undefined);
      }

      if (this.attMap['RelatedPartySoldPropReceived'] && this.attMap['RelatedPartySoldPropReceived'][0]) {
        this.RelatedPartySoldPropReceived = this.attMap['RelatedPartySoldPropReceived'][0] === '1';
      }
      if (this.attMap['DisposWasAfterDeathRltdParties'] && this.attMap['DisposWasAfterDeathRltdParties'][0]) {
        this.DisposWasAfterDeathRltdParties = this.attMap['DisposWasAfterDeathRltdParties'][0] === '1';
      }
      if (this.attMap['YouSoldPropertyReceived'] && this.attMap['YouSoldPropertyReceived'][0]) {
        this.YouSoldPropertyReceived = this.attMap['YouSoldPropertyReceived'][0] === '1';
      }
      if (this.attMap['DisposWasInvoluntaryConversion'] && this.attMap['DisposWasInvoluntaryConversion'][0]) {
        this.DisposWasInvoluntaryConversion = this.attMap['DisposWasInvoluntaryConversion'][0] === '1';
      }
      if (this.attMap['ExchangeDisposNotTaxAvoidance'] && this.attMap['ExchangeDisposNotTaxAvoidance'][0]) {
        this.ExchangeDisposNotTaxAvoidance = this.attMap['ExchangeDisposNotTaxAvoidance'][0] === '1';
      }
      setTimeout(() => {
        this.leidComponents.toArray().forEach((element: TemplateLeidSelectorComponent, index: number) => {
          switch (index) {
            case 0:
              element.fillLEID(data.primaryleid);
              break;
            case 1:
              if (data.secondaryleid) {
                element.fillLEID(data.secondaryleid);
              }
              break;
          }
        });
      });
      this.cdref.detectChanges();
    } else if (this.sharedService.leid !== '') {
      this.statementId = (this.trackerTabsService.getActiveTrackerTab()?.getActiveFormState().statementId!).toString();
      setTimeout(() => {
        this.leidComponents.toArray()[0].fillLEID(this.sharedService.leid);
      });
    }else{
      this.nameChangeChecked = true;
    }
  }

  onTransferorChanged(selectedTransferor: DSTEntityDetails | null): void {
    this.transferor = selectedTransferor;
    this.headerComponent.loadConsolGroups(selectedTransferor?.LEID!, this.dcnId);
    this.DREMsg = this.sharedService.areEntitiesDisregarded([this.transferor!, this.transferee!]);
    this.showDREMsg = !!this.DREMsg;

    if (this.DatePropActuallyTransferred && this.transferor?.LEID) {
      this.startLoader = true;
      this.sharedService.checkForEntityNameChange(this.statementId,
        this.transferor.LEID,
        this.sharedService.getTransDateStr(this.DatePropActuallyTransferred),
        this.sharedService.getActiveFormState().taxYear.toString()
      ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response: EntityNameChange[]) => {
        if (response && response[0]?.LE_NAME) {
          this.transferor!.ENTITY = response[0].LE_NAME; // override entity name
        }
          this.nameChangeChecked = true;
      }, (error: HttpErrorResponse) => {
        console.log(error);
        this.dstSharedService.showAlert('error', error.message);
      }).add(() => {
        this.startLoader = false;
      });
    }else if(!this.DatePropActuallyTransferred) {
      this.nameChangeChecked = true;

    }
  }

  onTransfereeChanged(selectedTransferor: DSTEntityDetails | null): void {
    this.transferee = selectedTransferor;
    if (!selectedTransferor) {
      return;
    }

    if (this.DatePropActuallyTransferred && this.transferee?.LEID) {
      this.startLoader = true;
      this.sharedService.checkForEntityNameChange(this.statementId,
        this.transferee.LEID,
        this.sharedService.getTransDateStr(this.DatePropActuallyTransferred),
        this.sharedService.getActiveFormState().taxYear.toString()
      ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response: EntityNameChange[]) => {
        if (response && response[0]?.LE_NAME) {
          this.transferee!.ENTITY = response[0].LE_NAME; // override entity name
        }
          this.nameChangeChecked = true;
      }, (error: HttpErrorResponse) => {
        console.log(error);
        this.dstSharedService.showAlert('error', error.message);
      }).add(() => {
        this.startLoader = false;
      });
    }
    this.DREMsg = this.sharedService.areEntitiesDisregarded([this.transferee!, this.transferor!]);
    this.showDREMsg = !!this.DREMsg;
  }

  onFormOptionChanged(selectedOptionID: Event): void {
    this.selectedOptionID = selectedOptionID;
  }

  OnConsolGroupChanged(consolGroup: DSTConsolGroup): void {
    this.dcnId = consolGroup.DCNID;
  }

  save(): void {
    const trackerTab: TrackerTabState | null = this.trackerTabsService.getActiveTrackerTab();
    if (!trackerTab) {
      return;
    }
    const isPlaceholderChecked: boolean = trackerTab.isPlaceholderChecked;
    if (!this.isFormValid(isPlaceholderChecked) || !this.sharedService.confirmDRE([this.transferor, this.transferee])) {
      return;
    } else {
      this.normalizeAmountFields();
      this.onCalculateAll();
      this.startLoader = true;
      const formState: DSTFormState = this.sharedService.getActiveFormState();
      const params: { [param: string]: string } = {
        'statementID': this.statementId !== '' ? this.statementId : '0',
        'taxYear': formState.taxYear.toString(),
        'taxYearId': formState.taxYearId.toString(),
        'dcnId': this.dcnId ? toSaveString(this.dcnId) : '',
        'returnPeriodId': formState.returnPeriodId.toString(),
        'formId': formState.formId.toString(),
        'primaryEntityId': safeEntityId(this.transferor),
        'secondaryEntityId': this.ExchangeMadeWithRelatedParty === true ? safeEntityField(this.transferee, 'ENTITYID') : '',
        'branchEntityId': '',
        'comments': '',
        'csStatementId': formState.csStatementId?.toString() || '0',
        'placeHolder': isPlaceholderChecked ? '1' : '0',
        'attachmentFileName': '',
      };

      const jsonObject = {
        'TransferorLEID': safeEntityField(this.transferor, 'LEID'),
        'TransfereeLEID': this.ExchangeMadeWithRelatedParty === true ? safeEntityField(this.transferee, 'LEID') : '',
        'DescOfLikeKindPropertyGivenUp': this.DescOfLikeKindPropertyGivenUp !== null ? this.DescOfLikeKindPropertyGivenUp : '',
        'DescriptionOfOtherPropertyGivenUp': this.DescriptionOfOtherPropertyGivenUp !== null ? this.DescriptionOfOtherPropertyGivenUp : '',
        'DescOfLikeKindPropertyReceived': this.DescOfLikeKindPropertyReceived !== null ? this.DescOfLikeKindPropertyReceived : '',
        'DescriptionOfOtherPropertyRcvd': this.DescriptionOfOtherPropertyRcvd !== null ? this.DescriptionOfOtherPropertyRcvd : '',
        'DateLikeKindPropertyGivenUpAcq': this.toDateOnly(this.DateLikeKindPropertyGivenUpAcq),
        'DatePropActuallyTransferred': this.toDateOnly(this.DatePropActuallyTransferred),
        'DateLikeKindPropRcvdIdentified': this.toDateOnly(this.DateLikeKindPropRcvdIdentified),
        'DatePropertyActuallyReceived': this.toDateOnly(this.DatePropertyActuallyReceived),
        'ExchangeMadeWithRelatedParty': this.ExchangeMadeWithRelatedParty !== undefined ? this.ExchangeMadeWithRelatedParty === true ? '1' : '0' : '',
        'MissingEINReason': '',
        'RelationshipToYou': this.ExchangeMadeWithRelatedParty === true ? this.RelationshipToYou !== null ? this.RelationshipToYou : '' : '',
        'RelatedPartySoldPropReceived': this.ExchangeMadeWithRelatedParty === true ? this.RelatedPartySoldPropReceived !== undefined ? this.RelatedPartySoldPropReceived === true ? '1' : '0' : '0' : '',
        'YouSoldPropertyReceived': this.ExchangeMadeWithRelatedParty === true ? this.YouSoldPropertyReceived !== undefined ? this.YouSoldPropertyReceived === true ? '1' : '0' : '0' : '',
        'DisposWasAfterDeathRltdParties': this.ExchangeMadeWithRelatedParty === true ? this.DisposWasAfterDeathRltdParties ? '1' : '0' : '',
        'DisposWasInvoluntaryConversion': this.ExchangeMadeWithRelatedParty === true ? this.DisposWasInvoluntaryConversion ? '1' : '0' : '',
        'ExchangeDisposNotTaxAvoidance': this.ExchangeMadeWithRelatedParty === true ? this.ExchangeDisposNotTaxAvoidance ? '1' : '0' : '',
        'PrincipalPrpsRltdPartyExchStmtExplanation': this.ExchangeMadeWithRelatedParty === true ? this.PrincipalPrpsRltdPartyExchStmtExplanation : '',
        'GainInMultiAssetExchangesStmtGainInMultiAssetExchangeAmount': stripAmountFormatting(this.GainInMultiAssetExchangesStmtGainInMultiAssetExchangeAmount),
        'GainInMultiAssetExchangesStmtGainInMultiAssetExchangeExplanation': this.GainInMultiAssetExchangesStmtGainInMultiAssetExchangeExplanation,
        'FMVOfOtherPropertyGivenUp': stripAmountFormatting(this.FMVOfOtherPropertyGivenUp),
        'AdjBasisOfOtherPropertyGivenUp': stripAmountFormatting(this.AdjBasisOfOtherPropertyGivenUp),
        'GainLossOnOtherPropertyGivenUp': stripAmountFormatting(this.GainLossOnOtherPropertyGivenUp),
        'CashFMVAndNetLiabRedByExpenses': stripAmountFormatting(this.CashFMVAndNetLiabRedByExpenses),
        'FMVOfLikeKindPropertyReceived': stripAmountFormatting(this.FMVOfLikeKindPropertyReceived),
        'AmountRealized': stripAmountFormatting(this.AmountRealized),
        'AdjBasisOfLikeKindPropGivenUp': stripAmountFormatting(this.AdjBasisOfLikeKindPropGivenUp),
        'RealizedGainOrLoss': stripAmountFormatting(this.RealizedGainOrLoss),
        'SmallerGainOrLoss': stripAmountFormatting(this.SmallerGainOrLoss),
        'OrdinaryIncmUndRecaptureRules': stripAmountFormatting(this.OrdinaryIncmUndRecaptureRules),
        'SmallerGainLossLessOrdnryIncm': stripAmountFormatting(this.SmallerGainLossLessOrdnryIncm),
        'RecognizedGain': stripAmountFormatting(this.RecognizedGain),
        'DeferredGainOrLoss': stripAmountFormatting(this.DeferredGainOrLoss),
        'BasisOfLikeKindPropertyRcvd': stripAmountFormatting(this.BasisOfLikeKindPropertyRcvd),
        'BasisOfLikeKindIntagblePropertyRcvd': stripAmountFormatting(this.BasisOfLikeKindIntagblePropertyRcvd),
        'BasisOfLikeKindSect1245PropertyRcvd': stripAmountFormatting(this.BasisOfLikeKindSect1245PropertyRcvd),
        'BasisOfLikeKindSect1250PropertyRcvd': stripAmountFormatting(this.BasisOfLikeKindSect1250PropertyRcvd)

      };
      this.sharedService.saveStatemenet(params, jsonObject).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
        if (data) {
          this.dstSharedService.showAlert('success', 'Form Save Success!');
          this.startLoader = false;
          this.sharedService.setSavedStatementId(data.statementId);
          this.sharedService.switchTemplateMode(true);
          this.onSave.emit(); // emit without payload -- only notifies tracker to refresh grid
        }
      }, () => {
        this.dstSharedService.showAlert('error', 'Error!');
        this.startLoader = false;
      });
    }
  }

  clear(): void {
    if (this.statementId !== '' && this.statementId !== '0') {
      this.sharedService.switchTemplateMode(true);
    } else {
      this.onCancel.emit();
    }
  }

  check7(val: boolean) {
    this.ExchangeMadeWithRelatedParty = val;

  }

  check9(val: boolean) {
    this.RelatedPartySoldPropReceived = val;
  }

  check10(val: boolean) {
    this.YouSoldPropertyReceived = val;
  }

  check11a() {
    this.DisposWasAfterDeathRltdParties = !this.DisposWasAfterDeathRltdParties;
  }

  check11b() {
    this.DisposWasInvoluntaryConversion = !this.DisposWasInvoluntaryConversion;
  }

  check11c() {
    this.ExchangeDisposNotTaxAvoidance = !this.ExchangeDisposNotTaxAvoidance;
  }

  clearDate(index: number): void {
    switch (index) {
      case 1:
        this.DateLikeKindPropertyGivenUpAcq = '';
        this.form237.get('partOne')?.get('DateLikeKindPropertyGivenUpAcq')?.setValue(null);
        this.form237.get('partOne')?.get('DateLikeKindPropertyGivenUpAcq')?.markAsTouched();
        break;
      case 2:
        this.DatePropActuallyTransferred = '';
        this.form237.get('partOne')?.get('DatePropActuallyTransferred')?.setValue(null);
        this.form237.get('partOne')?.get('DatePropActuallyTransferred')?.markAsTouched();
        break;
      case 3:
        this.DateLikeKindPropRcvdIdentified = '';
        this.form237.get('partTwo')?.get('DateLikeKindPropRcvdIdentified')?.setValue(null);
        this.form237.get('partTwo')?.get('DateLikeKindPropRcvdIdentified')?.markAsTouched();
        break;
      case 4:
        this.DatePropertyActuallyReceived = '';
        this.form237.get('partTwo')?.get('DatePropertyActuallyReceived')?.setValue(null);
        this.form237.get('partTwo')?.get('DatePropertyActuallyReceived')?.markAsTouched();
        break;
      default:
        break;
    }
    console.log('🔄 First detectChanges() called for index:', index);
    this.cdref.detectChanges();
    
    // Additional clearing step to ensure ap-date-picker component updates
    setTimeout(() => {
      // 🚀 CRITICAL: Force clear date picker input fields if they still show values
      this.forceClearDatePickerInputs(index);
    }, 0);
  }

  /**
   * 🚀 CRITICAL: Force clear date picker input fields using DOM manipulation
   * This is a fallback method for stubborn date picker components
   */
  private forceClearDatePickerInputs(index: number): void {
    try {
      // Find the date picker input field by form control name
      const formControlNames = ['DateLikeKindPropertyGivenUpAcq', 'DatePropActuallyTransferred', 'DateLikeKindPropRcvdIdentified', 'DatePropertyActuallyReceived'];
      const formControlName = formControlNames[index - 1];
      
      if (formControlName) {
        // Try to find the input field within the date picker component
        const datePickerElement = document.querySelector(`[formcontrolname="${formControlName}"]`);
        if (datePickerElement) {
          const inputElement = datePickerElement.querySelector('input');
          if (inputElement && inputElement.value) {
            // Clear the input value and trigger change event
            inputElement.value = '';
            inputElement.dispatchEvent(new Event('input', { bubbles: true }));
            inputElement.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    } catch (error) {
      console.warn('Error clearing date picker input:', error);
    }
  }

  // A Date at local midnight becomes the previous UTC day in JSON
  // (2026-11-04 00:00 IST is 2026-11-03T18:30:00.000Z). Keep the calendar day.
  private toDateOnly(value: string | Date | null | undefined): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    if (value instanceof Date) {
      return isNaN(value.getTime()) ? '' : this.formatLocalYmd(value);
    }
    const raw = String(value).trim();
    if (!raw) {
      return '';
    }
    if (raw.includes('T')) {
      const parsed = new Date(raw);
      return isNaN(parsed.getTime()) ? '' : this.formatLocalYmd(parsed);
    }
    return raw.substring(0, 10);
  }

  private formatLocalYmd(date: Date): string {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${date.getFullYear()}-${month}-${day}`;
  }

  dateChange(event: any, index: number) {
    switch (index) {
      case 1:
        this.DateLikeKindPropertyGivenUpAcq = event.startDate.format('YYYY-MM-DD');
        break;
      case 2:
        this.DatePropActuallyTransferred = event.startDate.format('YYYY-MM-DD');
        const leids: string = this.sharedService.concatLEIDs([this.transferee!, this.transferor!]);
        if (!leids) {
          break;
        }
        this.startLoader = true;
        this.sharedService.checkForEntityNameChange(this.statementId,
          leids,
          this.sharedService.getTransDateStr(this.DatePropActuallyTransferred),
          this.sharedService.getActiveFormState().taxYear.toString()
        ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response: EntityNameChange[]) => {
          if (response) {
            for (let i = 0; i < leids.split(',').length; i++) {
              this.sharedService.updateEntityName(response[i].LEID,
                response[i].LE_NAME, [this.transferee!, this.transferor!], response[i].TAXTYPECODE);
            }
          }
          this.nameChangeChecked = true;
        }, (error: HttpErrorResponse) => {
          console.log(error);
          this.dstSharedService.showAlert('error', error.message);
        }).add(() => {
          this.startLoader = false;
        });

        break;

      case 3:
        this.DateLikeKindPropRcvdIdentified = event.startDate.format('YYYY-MM-DD');
        break;

      case 4:
        this.DatePropertyActuallyReceived = event.startDate.format('YYYY-MM-DD');
        break;


      default:
        break;
    }
  }

  onDPOpen(): void { // styling fix for gtw-ui
    const modalEle: Element | null = document.querySelector('ngx-daterangepicker-material');
    modalEle?.classList.add('gtw-web-components');
  }

  private parseAmount(value: string): number {
    const cleaned = stripAmountFormatting(value);
    if (cleaned === '') {
      return 0;
    }
    const num = parseFloat(cleaned);
    return isNaN(num) ? 0 : num;
  }

  private normalizeAmountFields(): void {
    this.GainInMultiAssetExchangesStmtGainInMultiAssetExchangeAmount =
      stripAmountFormatting(this.GainInMultiAssetExchangesStmtGainInMultiAssetExchangeAmount);
    this.FMVOfOtherPropertyGivenUp = stripAmountFormatting(this.FMVOfOtherPropertyGivenUp);
    this.AdjBasisOfOtherPropertyGivenUp = stripAmountFormatting(this.AdjBasisOfOtherPropertyGivenUp);
    this.GainLossOnOtherPropertyGivenUp = stripAmountFormatting(this.GainLossOnOtherPropertyGivenUp);
    this.CashFMVAndNetLiabRedByExpenses = stripAmountFormatting(this.CashFMVAndNetLiabRedByExpenses);
    this.FMVOfLikeKindPropertyReceived = stripAmountFormatting(this.FMVOfLikeKindPropertyReceived);
    this.AmountRealized = stripAmountFormatting(this.AmountRealized);
    this.AdjBasisOfLikeKindPropGivenUp = stripAmountFormatting(this.AdjBasisOfLikeKindPropGivenUp);
    this.RealizedGainOrLoss = stripAmountFormatting(this.RealizedGainOrLoss);
    this.SmallerGainOrLoss = stripAmountFormatting(this.SmallerGainOrLoss);
    this.OrdinaryIncmUndRecaptureRules = stripAmountFormatting(this.OrdinaryIncmUndRecaptureRules);
    this.SmallerGainLossLessOrdnryIncm = stripAmountFormatting(this.SmallerGainLossLessOrdnryIncm);
    this.RecognizedGain = stripAmountFormatting(this.RecognizedGain);
    this.DeferredGainOrLoss = stripAmountFormatting(this.DeferredGainOrLoss);
    this.BasisOfLikeKindPropertyRcvd = stripAmountFormatting(this.BasisOfLikeKindPropertyRcvd);
    this.BasisOfLikeKindIntagblePropertyRcvd = stripAmountFormatting(this.BasisOfLikeKindIntagblePropertyRcvd);
    this.BasisOfLikeKindSect1245PropertyRcvd = stripAmountFormatting(this.BasisOfLikeKindSect1245PropertyRcvd);
    this.BasisOfLikeKindSect1250PropertyRcvd = stripAmountFormatting(this.BasisOfLikeKindSect1250PropertyRcvd);
  }

  onCalculateAll(): void {
    this.normalizeAmountFields();
    if (this.FMVOfOtherPropertyGivenUp !== '' || this.AdjBasisOfOtherPropertyGivenUp !== '') {
      if (this.FMVOfOtherPropertyGivenUp === '') {
        this.GainLossOnOtherPropertyGivenUp = 0 - this.parseAmount(this.AdjBasisOfOtherPropertyGivenUp) + '';
      } else if (this.AdjBasisOfOtherPropertyGivenUp === '') {
        this.GainLossOnOtherPropertyGivenUp = this.parseAmount(this.FMVOfOtherPropertyGivenUp) - 0 + '';
      } else {
        this.GainLossOnOtherPropertyGivenUp = this.parseAmount(this.FMVOfOtherPropertyGivenUp) - this.parseAmount(this.AdjBasisOfOtherPropertyGivenUp) + '';
      }

    }

    if (this.CashFMVAndNetLiabRedByExpenses !== '' || this.FMVOfLikeKindPropertyReceived !== '') {
      if (this.CashFMVAndNetLiabRedByExpenses === '') {
        this.AmountRealized = 0 + this.parseAmount(this.FMVOfLikeKindPropertyReceived) + '';
      } else if (this.FMVOfLikeKindPropertyReceived === '') {
        this.AmountRealized = this.parseAmount(this.CashFMVAndNetLiabRedByExpenses) + 0 + '';
      } else {
        this.AmountRealized = this.parseAmount(this.CashFMVAndNetLiabRedByExpenses) + this.parseAmount(this.FMVOfLikeKindPropertyReceived) + '';
      }

    }

    if (this.AmountRealized && this.AdjBasisOfLikeKindPropGivenUp && this.AmountRealized !== '' && this.AdjBasisOfLikeKindPropGivenUp !== '') {
      this.RealizedGainOrLoss = this.parseAmount(this.AmountRealized) - this.parseAmount(this.AdjBasisOfLikeKindPropGivenUp) + '';
    }

    if (this.CashFMVAndNetLiabRedByExpenses && this.RealizedGainOrLoss && this.CashFMVAndNetLiabRedByExpenses !== '' && this.RealizedGainOrLoss !== '') {
      if (this.parseAmount(this.CashFMVAndNetLiabRedByExpenses) < this.parseAmount(this.RealizedGainOrLoss)) {
        if (this.parseAmount(this.CashFMVAndNetLiabRedByExpenses) > 0) {
          this.SmallerGainOrLoss = this.CashFMVAndNetLiabRedByExpenses;
        } else {
          this.SmallerGainOrLoss = 0 + '';
        }
      } else {
        if (this.parseAmount(this.RealizedGainOrLoss) > 0) {
          this.SmallerGainOrLoss = this.RealizedGainOrLoss;
        } else {
          this.SmallerGainOrLoss = 0 + '';
        }
      }
    }

    if (this.SmallerGainOrLoss !== '' || this.OrdinaryIncmUndRecaptureRules !== '') {
      if (this.SmallerGainOrLoss === '') {
        const calc = 0 - this.parseAmount(this.OrdinaryIncmUndRecaptureRules);
        if (calc < 0) {
          this.SmallerGainLossLessOrdnryIncm = 0 + '';
        } else {
          this.SmallerGainLossLessOrdnryIncm = calc + '';
        }
      } else if (this.OrdinaryIncmUndRecaptureRules === '') {
        const calc = this.parseAmount(this.SmallerGainOrLoss) - 0;
        if (calc < 0) {
          this.SmallerGainLossLessOrdnryIncm = 0 + '';
        } else {
          this.SmallerGainLossLessOrdnryIncm = calc + '';
        }
      } else {
        const calc = this.parseAmount(this.SmallerGainOrLoss) - this.parseAmount(this.OrdinaryIncmUndRecaptureRules);
        if (calc < 0) {
          this.SmallerGainLossLessOrdnryIncm = 0 + '';
        } else {
          this.SmallerGainLossLessOrdnryIncm = calc + '';
        }
      }

    }

    if (this.SmallerGainLossLessOrdnryIncm !== '' || this.OrdinaryIncmUndRecaptureRules !== '') {
      if (this.SmallerGainLossLessOrdnryIncm === '') {
        this.RecognizedGain = 0 + this.parseAmount(this.OrdinaryIncmUndRecaptureRules) + '';
      } else if (this.OrdinaryIncmUndRecaptureRules === '') {
        this.RecognizedGain = this.parseAmount(this.SmallerGainLossLessOrdnryIncm) + 0 + '';
      } else {
        this.RecognizedGain = this.parseAmount(this.SmallerGainLossLessOrdnryIncm) + this.parseAmount(this.OrdinaryIncmUndRecaptureRules) + '';
      }


    }

    if (this.RecognizedGain !== '' || this.RealizedGainOrLoss !== '') {
      if (this.RecognizedGain === '') {
        this.DeferredGainOrLoss = this.parseAmount(this.RealizedGainOrLoss) - 0 + '';
      } else if (this.RealizedGainOrLoss === '') {
        this.DeferredGainOrLoss = 0 - this.parseAmount(this.RecognizedGain) + '';
      } else {
        this.DeferredGainOrLoss = this.parseAmount(this.RealizedGainOrLoss) - this.parseAmount(this.RecognizedGain) + '';
      }

    }

    if (this.AdjBasisOfLikeKindPropGivenUp !== '' || this.CashFMVAndNetLiabRedByExpenses !== '' || this.RecognizedGain !== '') {
      if (this.AdjBasisOfLikeKindPropGivenUp === '') {
        if (this.CashFMVAndNetLiabRedByExpenses === '') {
          this.BasisOfLikeKindPropertyRcvd = (0 + this.parseAmount(this.RecognizedGain)) - 0 + '';
        } else if (this.RecognizedGain === '') {
          this.BasisOfLikeKindPropertyRcvd = 0 - this.parseAmount(this.CashFMVAndNetLiabRedByExpenses) + '';
        } else {
          this.BasisOfLikeKindPropertyRcvd = (0 + this.parseAmount(this.RecognizedGain)) - this.parseAmount(this.CashFMVAndNetLiabRedByExpenses) + '';
        }
      } else if (this.CashFMVAndNetLiabRedByExpenses === '') {
        if (this.AdjBasisOfLikeKindPropGivenUp === '') {
          this.BasisOfLikeKindPropertyRcvd = (0 + this.parseAmount(this.RecognizedGain)) - 0 + '';
        } else if (this.RecognizedGain === '') {
          this.BasisOfLikeKindPropertyRcvd = (this.parseAmount(this.AdjBasisOfLikeKindPropGivenUp) + 0) - 0 + '';
        } else {
          this.BasisOfLikeKindPropertyRcvd = (this.parseAmount(this.AdjBasisOfLikeKindPropGivenUp) + this.parseAmount(this.RecognizedGain)) - 0 + '';
        }
      } else if (this.RecognizedGain === '') {
        if (this.CashFMVAndNetLiabRedByExpenses === '') {
          this.BasisOfLikeKindPropertyRcvd = (this.parseAmount(this.AdjBasisOfLikeKindPropGivenUp) + 0) - 0 + '';
        } else if (this.AdjBasisOfLikeKindPropGivenUp === '') {
          this.BasisOfLikeKindPropertyRcvd = 0 - this.parseAmount(this.CashFMVAndNetLiabRedByExpenses) + '';
        } else {
          this.BasisOfLikeKindPropertyRcvd = (this.parseAmount(this.AdjBasisOfLikeKindPropGivenUp) + 0) - this.parseAmount(this.CashFMVAndNetLiabRedByExpenses) + '';
        }
      } else {
        this.BasisOfLikeKindPropertyRcvd = (this.parseAmount(this.AdjBasisOfLikeKindPropGivenUp) + this.parseAmount(this.RecognizedGain)) - this.parseAmount(this.CashFMVAndNetLiabRedByExpenses) + '';
      }

    }
  }

  isFormValid(placeholder: boolean): boolean {
    if (!this.transferor) {
      this.dstSharedService.showAlert('error', 'Please specify the LEID for the Reporting Entity');
      return false;
    }
    if (placeholder) {
      return true;
    }
    if (this.DescOfLikeKindPropertyGivenUp === '' || this.DescOfLikeKindPropertyReceived === '') {
      this.dstSharedService.showAlert('error', 'Please specify the Description of the Like-Kind Property Given Up');
      return false;
    }
    if (this.ExchangeMadeWithRelatedParty) {
      if (!this.transferee) {
        this.dstSharedService.showAlert('error', 'Please specify LEID the of Related Party');
        return false;
      }
      if (this.ExchangeDisposNotTaxAvoidance && this.PrincipalPrpsRltdPartyExchStmtExplanation === '') {
        this.dstSharedService.showAlert('error', 'Please specify an explanation');
        return false;
      }
    }
    if (this.GainInMultiAssetExchangesStmtGainInMultiAssetExchangeAmount !== '' && this.GainInMultiAssetExchangesStmtGainInMultiAssetExchangeExplanation === '') {
      this.dstSharedService.showAlert('error', 'Please specify the details of the calculation');
      return false;
    }

    return true;
  }
}

export type FormFieldType = {
  event: Event;
  value: string;
}
